import { render, staticRenderFns } from "./esta_personasregimen.vue?vue&type=template&id=ef13355a"
import script from "./esta_personasregimen.vue?vue&type=script&lang=js"
export * from "./esta_personasregimen.vue?vue&type=script&lang=js"
import style0 from "./esta_personasregimen.vue?vue&type=style&index=0&id=ef13355a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports